await loadComponent('./components/mc-element.js', false);
await loadComponent('./res/mc-shopify.js', false);

class CartRemove extends McElement {

  connectedCallback() {
    if(!this.hasAttribute('data-key')) {
      console.error('CartRemove component requires a data-key attribute.');
      return;
    }
    this.addEventListener('click', () => {
      this.removeItem();
    });
  }

  removeItem = () => {
    const key = this.getAttribute('data-key');
    if (!key) return;
    
    McShopify.updateCartLine({
      id: key,
      quantity: 0
    });

  }
}

if (!customElements.get('cart-remove')) {
  customElements.define('cart-remove', CartRemove);
}

window.CartRemove = CartRemove;